module.exports = __webpack_public_path__ + "img/stock5.a9069d35.png";